import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { useMutation } from '@apollo/client'
import { UPDATE_TASK_MUTATION } from '../query/gqlQueries.js'
import { GripVertical, Edit2 } from 'lucide-react' // Import icons
import './TaskCard.scss'

export function TaskCard({ task, isOverlay, onEditTask }) {
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
    id: task.id,
    data: { type: 'Task', task }
  })

  const [updateTask] = useMutation(UPDATE_TASK_MUTATION)

  const style = {
    transition,
    transform: CSS.Translate.toString(transform)
  }

  const handleAddTime = async () => {
    const currentTimeSpent = Number(task.properties.timeSpent) || 0
    const newTimeSpent = currentTimeSpent + 0.5
    try {
      await updateTask({
        variables: {
          identity: task.id,
          input: { timeSpent: newTimeSpent }
        }
      })
      console.log('Task updated successfully')
    } catch (error) {
      console.error('Error updating task:', error)
    }
  }

  // The Work app's TV card: how urgent (the bar), the title, who, when, the
  // hours, and how far its subtasks have got.
  const p = task.properties || {}
  const raw = String(p.priority || 'low').toLowerCase()
  const prio = raw === 'med' ? 'medium' : raw
  const due = p.dueDate ? new Date(p.dueDate) : null
  const late = due && !isNaN(due) && due.getTime() < new Date().setHours(0, 0, 0, 0) && task.status !== 'DONE'
  const hrs = (v) => Math.round((Number(v) || 0) * 10) / 10

  return (
    <div ref={setNodeRef} style={style} className={`task-card prio-${prio} ${isDragging ? 'dragging' : ''} ${isOverlay ? 'overlay' : ''}`}
      onClick={() => onEditTask && onEditTask(task)}>
      <div className="drag-handle" {...attributes} {...listeners} onClick={(e) => e.stopPropagation()} aria-label={`Move task: ${task.content}`}>
        <GripVertical size={16} />
      </div>
      <span className="prio-bar" title={`${p.priority || 'Low'} priority`} />
      <div className="task-content">
        <div className="task-title">{task.content}</div>
        <div className="task-meta">
          {task.avatar ? <img src={task.avatar} alt={p.assignee} className="task-avatar" />
            : p.assignee ? <span className="task-avatar task-avatar-text">{p.assignee[0]}</span> : null}
          {due && !isNaN(due) && <span className={`task-due ${late ? 'late' : ''}`}>{due.toLocaleDateString(undefined, { day: 'numeric', month: 'short' })}</span>}
          <span className="task-hours">{hrs(p.timeSpent)}/{hrs(p.timeBudget)} h</span>
        </div>
        {task.subs && task.subs.total > 0 && (
          <div className={`task-subs ${task.subs.done === task.subs.total ? 'all' : ''}`}>
            <span className="subs-bar"><span style={{ width: `${(task.subs.done / task.subs.total) * 100}%` }} /></span>
            <span>{task.subs.done}/{task.subs.total}</span>
          </div>
        )}
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation()
          if (onEditTask) onEditTask(task)
        }}
        className="add-time-button" aria-label="Edit task">
        <Edit2 size={14} />
      </button>
    </div>
  )
}
